import { render, staticRenderFns } from "./foodPackageCate.vue?vue&type=template&id=30c276b5&scoped=true&"
import script from "./foodPackageCate.vue?vue&type=script&lang=js&"
export * from "./foodPackageCate.vue?vue&type=script&lang=js&"
import style0 from "./foodPackageCate.vue?vue&type=style&index=0&id=30c276b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c276b5",
  null
  
)

export default component.exports